  <div class="row">
    <div [ngClass]="mapColumnClass" class="map-column">
      <div class="position-relative">
        <div
          id="map" #mapRef
          leaflet
          [leafletOptions]="mapOptions"
          (leafletMapReady)="onMapReady($event)"
        >
        </div>

        @if (showSidebarRevealButton) {
          <button
            aria-label="Show locations panel"
            class="map-sidebar-toggle map-sidebar-toggle-reveal btn btn-sm bg-white border shadow-sm"
            title="Show locations panel"
            type="button"
            (click)="toggleSidebarCollapsed()"
          >
            <i class="ri-side-bar-line"></i>
          </button>
        }

        @if (showRiskColouring && showRiskLegend) {
          <div #riskLegend class="risk-map-legend bg-white border rounded shadow-sm px-2 py-1">
            @for (level of riskLegendLevels; track level) {
              <div class="d-flex align-items-center small mb-1">
                <span class="legend-swatch me-2" [style.background]="getRiskLegendColour(level)"></span>
                <span class="text-muted">{{ getRiskLegendLabel(level) }}</span>
              </div>
            }
            <div class="d-flex align-items-center small">
              <span class="legend-swatch legend-swatch-unassessed me-2"></span>
              <span class="text-muted">Not assessed</span>
            </div>
          </div>
        }
      </div>
    </div>

    <div
      class="map-sidebar"
      [class.settings-expanded]="settingsPanelExpanded"
      [class.sidebar-collapsed]="sidebarCollapsible && sidebarCollapsed"
      [class.sidebar-collapsible]="sidebarCollapsible"
      [ngClass]="wideSidebar ? 'col-3' : 'col-2'"
    >
      @if (sidebarCollapsible) {
        <button
          aria-label="Hide locations panel"
          class="map-sidebar-toggle map-sidebar-toggle-hide btn btn-sm bg-white border shadow-sm"
          title="Hide locations panel"
          type="button"
          (click)="toggleSidebarCollapsed()"
        >
          <i class="ri-contract-right-line"></i>
        </button>
      }

      @if (companyId != undefined) {
        <div class="search-container mt-2" #container>
          <div class="input-wrapper">
            <input
              class="form-control"
              [(ngModel)]="searchTerm"
              placeholder="User search or select..."
              type="text"
              (input)="onUserSearchInput()"
              (focus)="showDropdown = true"
            />
            <button
              *ngIf="searchTerm"
              class="clear-btn"
              (click)="clearSelectionClick($event)"
            >
              ✕
            </button>
          </div>

        
          <ul class="dropdown" *ngIf="showDropdown">
            <li
              *ngFor="let item of filteredItems"
              (click)="selectItem(item)"
            >
              {{ item.username }}
            </li>
        
            <li *ngIf="filteredItems.length === 0" class="no-results">
              No results found
            </li>
          </ul>
        </div>
      }
      <!-- @if (companyId != undefined) {
        <div class="search-container mt-2" style="margin-left: -6px;" #container>
          <div class="input-wrapper">
            <select class="form-select form-select-sm"
                    [(ngModel)]="selectedTileLayerLabel"
                    (ngModelChange)="onTileLayerChange($event)">
              @for (option of tileLayerOptions; track option.label) {
                <option [value]="option.label">{{ option.label }}</option>
              }
            </select>
          </div>
        </div>
        <div class="search-container mt-2" style="margin-left: -6px;" #container>
          <div class="input-wrapper">
            <input
              type="text"
              class="form-control"
              [(ngModel)]="latLng"
              (input)="addLatLng()"
              placeholder="enter Lat,Lng"
            />
            <button
              *ngIf="latLng"
              class="clear-btn"
              (click)="clearLatLngClick($event)"
            >
              ✕
            </button>
          </div>
        </div>
      } -->

      @if (companyId != undefined || iccid != undefined) {
        <div class="location-settings location-list-button" [class.location-list-attached]="!settingsPanelExpanded" (click)="toggleLocationsPanel()">
          <div class="location-settings-header">
            <span><i class="ri-map-pin-line me-1"></i>Locations</span>
            <i [class]="settingsPanelExpanded ? 'ri-arrow-right-s-line' : 'ri-arrow-down-s-line'"></i>
          </div>
        </div>
      }

      @if (!settingsPanelExpanded) {
      <div class="location-list-box" [class.location-list-neutral]="showRiskColouring">
      @if (iccid != undefined) {
        <div class="history-range history-range-boxed" [class.history-range-open]="customRangeEditing">
          <div class="history-range-row">
            <label class="fw-medium fs-14 mb-0">Range</label>
            <select class="form-select form-select-sm history-range-select"
                    [ngModel]="historyDateRange" (ngModelChange)="onHistoryRangeChange($event)">
              <option value="last">Last Location</option>
              @if (showFullRangeOptions) {
                <option value="24h">Last 24 Hours</option>
                <option value="7d">Last 7 Days</option>
                <option value="30d">Last 30 Days</option>
                <option value="custom">Custom</option>
              }
            </select>
          </div>

          @if (historyDateRange === 'custom' && customRangeApplied && !customRangeEditing) {
            <div class="history-range-applied fs-11 mt-1">
              <span class="text-muted">{{ appliedRangeLabel }}</span>
              <a href="javascript:void(0);" class="ms-1" (click)="openCustomRangeEditor()">Edit</a>
            </div>
          }

          @if (customRangeEditing) {
            <div class="history-range-custom">
              <app-dropdown-date
                [dateFormat]="filterDateFormat"
                [initialDate]="filterDateStart"
                [monthSelector]="false"
                [title]="'Start Date'"
                (selectOnChangeEvent)="dateStartFilterChanged($event)"
              ></app-dropdown-date>
              <app-dropdown-date
                [dateFormat]="filterDateFormat"
                [initialDate]="filterDateEnd"
                [monthSelector]="false"
                [title]="'End Date'"
                (selectOnChangeEvent)="dateEndFilterChanged($event)"
              ></app-dropdown-date>

              <div class="history-range-actions">
                <button type="button" class="btn btn-sm btn-light" (click)="onCustomRangeCancel()">Cancel</button>
                <button type="button" class="btn btn-sm btn-success" (click)="onCustomRangeApply()">Apply</button>
              </div>
            </div>
          }
        </div>
      }
      <div #scrollContainer class="row perfect-scrollbar mt-2" *ngIf="filteredcoordinates.length > 0; else checkLoadingStatus">
        <div class="col-12 cardx" style="padding-left: 0;" [attr.data-loc-id]="coordinate.id" *ngFor="let coordinate of filteredcoordinates">
          <div class="card card-animate" [class.location-group-card]="isExpandableGroup(coordinate)" (click)="onCardClick(coordinate, $event)">
            <div class="card-body" style="padding: 10px;" [ngStyle]="{'background-color': getCardColour(coordinate) }">

              @if (isExpandableGroup(coordinate)) {
                <i class="location-group-chevron" [class]="isGroupExpanded(coordinate) ? 'ri-arrow-down-s-line' : 'ri-arrow-right-s-line'"></i>
              }

              @if (iccid != undefined && coordinate.countryOnly===true) {
                <div class="float-end ms-2">
                  <span [class]="locationStatusClass(coordinate)">{{ locationStatusLabel(coordinate) }}</span>
                </div>
              }

              <div *ngIf="(zoomedIn == zoomLevelWorld && !showAllLocationCards && getCountrySimCount(coordinate) == 1 && (!showCurrentLocation || iccid == undefined))">
                <ng-container
                  *ngTemplateOutlet="worldViewSingleCoordinate; context: { $implicit: coordinate }">
                </ng-container>
              </div>

              <div *ngIf="(zoomedIn == zoomLevelWorld && !showAllLocationCards && getCountrySimCount(coordinate) > 1)">
                <ng-container
                  *ngTemplateOutlet="worldViewMutlipleCoordinates; context: { $implicit: coordinate }">
                </ng-container>
              </div>

              <div *ngIf="(zoomedIn != zoomLevelWorld || (showCurrentLocation && iccid != undefined) || showAllLocationCards)">
                <ng-container
                  *ngTemplateOutlet="coordinateView; context: { $implicit: coordinate }">
                </ng-container>
              </div>

              <div *ngIf="!(sureSimLiveData != undefined && showCurrentLocation); else simCurrentLocationView"></div>

              <!-- <div class="d-flex col-12 mt-0">
                <p class="fs-12 mb-1 text-align-left text-muted">
                  <span>Lat: {{coordinate.lat}}</span>
                </p>
              </div>
              <div class="d-flex col-12 mt-0">
                <p class="fs-12 mb-1 text-align-left text-muted">
                  <span>Lon: {{coordinate.lng}}</span>
                </p>
              </div> -->
              </div>
            </div>

            <!--RBW_20260716 - Child location cards for an expanded group, indented under the group card (inside the *ngFor so 'coordinate' is in scope)-->
            @if (isExpandableGroup(coordinate) && isGroupExpanded(coordinate)) {
              @for (child of groupChildren(coordinate); track $index) {
                <div class="card card-animate location-child-card" [attr.data-loc-id]="child.id" (click)="selectLocationCard(child, true)">
                  <div class="card-body" style="padding: 10px;" [ngStyle]="{'background-color': getCardColour(child) }">
                    <ng-container *ngTemplateOutlet="coordinateView; context: { $implicit: child }"></ng-container>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </div>
      }

      <div class="location-settings-dock">
        @if ((companyId != undefined || iccid != undefined) && showMapSettings) {
        <div class="location-settings map-settings" [class.location-settings-open]="mapSettingsExpanded">
          <div class="location-settings-header" (click)="toggleMapSettingsPanel()">
            <span><i class="ri-road-map-line me-1"></i>Map Settings</span>
            <i [class]="mapSettingsExpanded ? 'ri-arrow-down-s-line' : 'ri-arrow-right-s-line'"></i>
          </div>

          @if (mapSettingsExpanded) {
            <div class="location-settings-body mt-2">

              @if (companyId != undefined) {
                <div class="location-scope-row mb-2">
                  <div class="location-scope-text">
                    <div class="fw-medium">Location Grouping</div>
                    <div class="fs-11 text-muted">Group SIMs by country. Turn off to list every SIM individually.</div>
                  </div>
                  <div class="form-check form-switch form-switch-md location-scope-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="locGroupByCountry-switch"
                           [checked]="worldCardMode === 'countries'" (change)="onGroupingToggle()">
                  </div>
                </div>
              }

              @if (showRiskColouring) {
                <div class="location-scope-row mb-2">
                  <div class="location-scope-text">
                    <div class="fw-medium">Traveller Counts</div>
                    <div class="fs-11 text-muted">Show one count per country. Turn off to show an individual pin for every SIM.</div>
                  </div>
                  <div class="form-check form-switch form-switch-md location-scope-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="locRiskBubbles-switch"
                           [checked]="showCountBubbles" (change)="onCountBubblesToggle()">
                  </div>
                </div>
              }

              <div class="location-scope-row mb-2">
                <div class="location-scope-text">
                  <div class="fw-medium">Auto-zoom on card selection</div>
                  <div class="fs-11 text-muted">Zoom the map to a location when its card is clicked.</div>
                </div>
                <div class="form-check form-switch form-switch-md location-scope-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="locAutoZoom-switch"
                         [checked]="zoomInOnSelection" (change)="zoomInClick()">
                </div>
              </div>

              @if (iccid != undefined) {
                <div class="location-scope-row">
                  <div class="location-scope-text">
                    <div class="fw-medium">Location Grouping</div>
                    <div class="fs-11 text-muted">Group the history into country visits. Off lists every recorded location.</div>
                  </div>
                  <div class="form-check form-switch form-switch-md location-scope-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="locGroupVisit-switch"
                           [checked]="worldCardMode === 'countries'" (change)="onGroupingToggle()">
                  </div>
                </div>
              }
            </div>
          }
        </div>
        }

        <!--RBW_20260713 – Location Settings-->
        @if (companyId != undefined || iccid != undefined) {
        <div class="location-settings" [class.location-settings-open]="locationSettingsExpanded">
          <div class="location-settings-header" (click)="toggleLocationSettingsPanel()">
            <span><i class="ri-settings-3-line me-1"></i>Location Settings</span>
            <i [class]="locationSettingsExpanded ? 'ri-arrow-down-s-line' : 'ri-arrow-right-s-line'"></i>
          </div>

          @if (locationSettingsExpanded) {
            <div class="location-settings-body mt-2">

              @if (iccid != undefined) {
                <div class="location-scope-row">
                  <div class="location-scope-text">
                    <div class="fw-medium">Location Tracking</div>
                    <div class="fs-11 text-muted">Enable location tracking for this user.</div>
                  </div>
                  <div class="form-check form-switch form-switch-md location-scope-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="locationTracking-switch"
                           [checked]="locationTrackingRequested" (change)="onLocationTrackingChange(!locationTrackingRequested)">
                  </div>
                </div>

                <!--RBW_20260922 - The switch shows what has been requested; this status shows what the platform is actually doing.
                                   Awaiting Confirmation means no location awareness is provided until the user clicks their link.-->
                <div class="location-defaults mb-3">
                  <div class="location-defaults-row">
                    <span>Status</span>
                    <span [class]="locationAwarenessStatusClass()">{{ locationAwarenessStatusDescription }}</span>
                  </div>

                  @if (locationAwaitingConsent) {
                    <div class="fs-11 text-muted">
                      Waiting for the user to confirm by email or SMS. Location is not being recorded.
                      <a href="javascript:void(0);" class="location-settings-link"
                         [class.disabled]="locationConsentResending" (click)="resendLocationConsent()">
                        {{ locationConsentResending ? 'Sending...' : 'Resend link' }}
                      </a>
                    </div>
                  }
                </div>

                <div class="location-settings-subheading">Settings Mode</div>
                <div class="location-mode-options mb-3">
                  <label class="location-mode-option" [class.selected]="!locationSettingsOverride">
                    <input type="radio" [name]="'locSettingsMode-' + iccid" [checked]="!locationSettingsOverride" (change)="onLocationOverrideChange(false)">
                    <span class="location-mode-title"><i class="ri-home-4-line location-mode-icon me-1"></i>Inherit</span>
                    <span class="location-mode-desc">Company defaults</span>
                  </label>
                  <label class="location-mode-option" [class.selected]="locationSettingsOverride">
                    <input type="radio" [name]="'locSettingsMode-' + iccid" [checked]="locationSettingsOverride" (change)="onLocationOverrideChange(true)">
                    <span class="location-mode-title"><i class="ri-user-3-line location-mode-icon me-1"></i>Override</span>
                    <span class="location-mode-desc">Custom for this user</span>
                  </label>
                </div>
              }

              <!--RBW_20260713 - SIM inheriting: show the owning company's defaults read-only-->
              @if (iccid != undefined && !locationSettingsOverride) {
                <div class="location-settings-subheading">Company Defaults Applied</div>
                <div class="location-defaults mb-2">
                  <div class="location-defaults-row">
                    <span>Accuracy floor</span>
                    <span class="location-defaults-value">{{ accuracyLabel(inheritedAccuracyLevel) }}</span>
                  </div>
                  <div class="location-defaults-row">
                    <span>Home guard</span>
                    <span class="location-defaults-value">{{ inheritedHomeGuard ? 'On' : 'Off' }}</span>
                  </div>
                  @if (showLastLocationOnlyCompany) {
                    <div class="location-defaults-row">
                      <span>Last location only</span>
                      <span class="location-defaults-value">{{ inheritedLastLocationOnly ? 'On' : 'Off' }}</span>
                    </div>
                  }
                  <!--RBW_20260723 - Hide the company home country when the user has their own (different) one: it isn't what Home Guard uses, so it's shown in its own section below-->
                  @if (inheritedHomeCountry && !userHomeCountryDiffers) {
                    <div class="location-defaults-row">
                      <span>Home country</span>
                      <span class="location-defaults-value">{{ inheritedHomeCountry }}</span>
                    </div>
                  }
                </div>

                <!--RBW_20260723 - The owning user's own home country overrides the company one for Home Guard; surface it separately when it differs-->
                @if (userHomeCountryDiffers) {
                  <div class="location-settings-subheading">User Home Country</div>
                  <div class="location-defaults mb-2">
                    <div class="location-defaults-row">
                      <span>Home country</span>
                      <span class="location-defaults-value">{{ userHomeCountry }}</span>
                    </div>
                  </div>
                }

                <div class="fs-11 text-muted">Switch to Override to customise settings for this user individually.</div>
              }

              <!--RBW_20260713 - Global Location Awareness screen: company settings are read-only here; edit them from within the company-->
              @if (companyId != undefined && readOnlySettings) {
                <div class="location-settings-subheading">Company Location Settings</div>
                <div class="location-defaults mb-2">
                  <div class="location-defaults-row">
                    <span>Accuracy floor</span>
                    <span class="location-defaults-value">{{ accuracyLabel(locationAccuracyLevel) }}</span>
                  </div>
                  <div class="location-defaults-row">
                    <span>Home guard</span>
                    <span class="location-defaults-value">{{ locationOutsideHomeCountryOnly ? 'On' : 'Off' }}</span>
                  </div>
                  @if (locationOutsideHomeCountryOnly && inheritedHomeCountry) {
                    <div class="location-defaults-row">
                      <span>Home country</span>
                      <span class="location-defaults-value">{{ inheritedHomeCountry }}</span>
                    </div>
                  }
                  <div class="location-defaults-row">
                    <span>Enable for new users by default</span>
                    <span class="location-defaults-value">{{ locationEnableForNewByDefault ? 'On' : 'Off' }}</span>
                  </div>
                  <div class="location-defaults-row">
                    <span>Country always visible</span>
                    <span class="location-defaults-value">{{ locationCountryAlwaysVisible ? 'On' : 'Off' }}</span>
                  </div>
                  <div class="location-defaults-row">
                    <span>Extended Offline alert after</span>
                    <span class="location-defaults-value">{{ travelRiskExtendedOfflineHours != null ? travelRiskExtendedOfflineHours + ' hours' : 'System default' }}</span>
                  </div>
                  @if (showUserOptIn) {
                    <div class="location-defaults-row">
                      <span>User opt-in required</span>
                      <span class="location-defaults-value">{{ locationRequireUserOptIn ? 'On' : 'Off' }}</span>
                    </div>
                  }
                  @if (showLastLocationOnlyCompany) {
                    <div class="location-defaults-row">
                      <span>Last location only</span>
                      <span class="location-defaults-value">{{ locationLastLocationOnly ? 'On' : 'Off' }}</span>
                    </div>
                  }
                </div>
                <a href="javascript:void(0);" class="fs-11 location-settings-link" (click)="goToCompanySettings()">Manage these settings within the company</a>
              }

              <!--RBW_20260713 - Company panel or SIM overriding: editable accuracy + tracking scope (not shown on the read-only global screen)-->
              @if ((companyId != undefined && !readOnlySettings) || locationSettingsOverride) {
                <div class="location-settings-subheading">Accuracy Level</div>
                <div class="location-accuracy-options mb-3">
                  <label class="location-accuracy-option" [class.selected]="locationAccuracyLevel === 1">
                    <input type="radio" [name]="'locAccuracy-' + (iccid ?? companyId)" [checked]="locationAccuracyLevel === 1" (change)="onLocationAccuracyChange(1)">
                    <span class="location-accuracy-label"><i class="ri-global-line me-1"></i>Country</span>
                    <span class="location-accuracy-desc">Nation-level only - least precise</span>
                  </label>
                  <label class="location-accuracy-option" [class.selected]="locationAccuracyLevel === 2">
                    <input type="radio" [name]="'locAccuracy-' + (iccid ?? companyId)" [checked]="locationAccuracyLevel === 2" (change)="onLocationAccuracyChange(2)">
                    <span class="location-accuracy-label"><i class="ri-building-line me-1"></i>Town / City</span>
                    <span class="location-accuracy-desc">Town, city or local district</span>
                  </label>
                  <label class="location-accuracy-option" [class.selected]="locationAccuracyLevel === 3">
                    <input type="radio" [name]="'locAccuracy-' + (iccid ?? companyId)" [checked]="locationAccuracyLevel === 3" (change)="onLocationAccuracyChange(3)">
                    <span class="location-accuracy-label"><i class="ri-pulse-line me-1"></i>Cell Tower</span>
                    <span class="location-accuracy-desc">Cell tower precision - most precise</span>
                  </label>
                </div>

                <div class="location-settings-subheading">Tracking Scope</div>
                <div class="location-scope-row mb-2">
                  <div class="location-scope-text">
                    <div class="fw-medium fs-14">Home guard</div>
                    <div class="fs-11 text-muted">Enable Location awareness only when roaming outside the users home country.</div>
                  </div>
                  <div class="form-check form-switch form-switch-md location-scope-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="locHomeGuard-switch"
                           [checked]="locationOutsideHomeCountryOnly" (change)="onLocationHomeGuardChange(!locationOutsideHomeCountryOnly)">
                  </div>
                </div>

                @if (iccid != undefined && locationOutsideHomeCountryOnly && effectiveHomeCountry) {
                  <div class="location-defaults mb-2">
                    <div class="location-defaults-row">
                      <span>Home country</span>
                      <span class="location-defaults-value">{{ effectiveHomeCountry }}</span>
                    </div>
                  </div>
                }

                @if ((companyId != undefined && showLastLocationOnlyCompany) || (iccid != undefined && showLastLocationOnlySim)) {
                  <div class="location-scope-row mb-2">
                    <div class="location-scope-text">
                      <div class="fw-medium fs-14">Last location only</div>
                      <div class="fs-11 text-muted">Only show the SIM's most recent location; hide location history.</div>
                    </div>
                    <div class="form-check form-switch form-switch-md location-scope-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="locLastLocationOnly-switch"
                             [checked]="locationLastLocationOnly" (change)="onLocationLastLocationOnlyChange(!locationLastLocationOnly)">
                    </div>
                  </div>
                }

                @if (companyId != undefined) {
                  <div class="location-scope-row mb-2">
                    <div class="location-scope-text">
                      <div class="fw-medium">Enable for new users by default</div>
                      <div class="fs-11 text-muted">Auto-enable location awareness when a new user connection is provisioned.</div>
                    </div>
                    <div class="form-check form-switch form-switch-md location-scope-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="locEnableNew-switch"
                             [checked]="locationEnableForNewByDefault" (change)="onLocationEnableForNewChange(!locationEnableForNewByDefault)">
                    </div>
                  </div>

                  <!--RBW_20261021 - The switch and the message it sends are one feature, so both wait on the same access.-->
                  @if (showUserOptIn) {
                    <div class="location-scope-row">
                      <div class="location-scope-text">
                        <div class="fw-medium">User opt-in required</div>
                        <div class="fs-11 text-muted">When enabled, a confirmation link is sent to the user when location awareness is activated. Location tracking will not begin until the user clicks the link to confirm their consent.</div>
                      </div>
                      <div class="form-check form-switch form-switch-md location-scope-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="locRequireOptIn-switch"
                               [checked]="locationRequireUserOptIn" (change)="onLocationRequireUserOptInChange(!locationRequireUserOptIn)">
                      </div>
                    </div>

                    @if (editLocationConsentTemplate.observed) {
                      <a href="javascript:void(0);" class="fs-11 location-settings-link" (click)="onEditLocationConsentTemplate()">
                        Edit the message sent to the user
                      </a>
                    }
                  }

                  <div class="location-scope-row mb-2 mt-2">
                    <div class="location-scope-text">
                      <div class="fw-medium">Country always visible</div>
                      <div class="fs-11 text-muted">Show the current country of every user, including users with location awareness switched off. Country only, never a precise position.</div>
                    </div>
                    <div class="form-check form-switch form-switch-md location-scope-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="locCountryAlwaysVisible-switch"
                             [checked]="locationCountryAlwaysVisible" (change)="onLocationCountryAlwaysVisibleChange(!locationCountryAlwaysVisible)">
                    </div>
                  </div>

                  <div class="location-scope-row mb-2">
                    <div class="location-scope-text">
                      <div class="fw-medium">Extended Offline alert after</div>
                      <div class="fs-11 text-muted">Hours abroad with no network activity before an Extended Offline alert is raised. Leave blank to use the system default.</div>
                    </div>
                    <div class="location-scope-switch d-flex align-items-center gap-1">
                      <input class="form-control form-control-sm" type="number" min="1" step="1" style="width:5rem;" id="locOfflineHours-input"
                             placeholder="Default" [value]="travelRiskExtendedOfflineHours ?? ''"
                             (change)="onTravelRiskExtendedOfflineHoursChange($any($event.target).value)">
                      <span class="fs-12 text-muted">hours</span>
                    </div>
                  </div>
                }
              }

              @if ((companyId != undefined && !readOnlySettings) || iccid != undefined) {
                <div class="location-settings-subheading mt-2">Reason for change</div>
                <input class="form-control form-control-sm mb-2" type="text" maxlength="512" id="locChangeReason-input"
                       placeholder="Optional: why are you changing these settings?"
                       [value]="locationChangeReason" (input)="onLocationChangeReasonChange($any($event.target).value)">
              }

              <a href="javascript:void(0);" class="fs-11 location-settings-link d-block mt-2" (click)="toggleVisibilityChanges()">
                <i [class]="visibilityChangesExpanded ? 'ri-arrow-down-s-line' : 'ri-arrow-right-s-line'"></i> Change history
              </a>
              @if (visibilityChangesExpanded) {
                <div class="location-defaults mt-1">
                  @if (visibilityChangesLoading) {
                    <div class="fs-11 text-muted"><i>Loading...</i></div>
                  } @else if (visibilityChanges.length === 0) {
                    <div class="fs-11 text-muted">No visibility changes in the last 90 days.</div>
                  } @else {
                    @for (change of visibilityChanges; track $index) {
                      <div class="py-1 border-bottom">
                        <div class="fs-12">
                          <span class="fw-medium">{{ getVisibilitySettingLabel(change) }}</span>
                          @if (getVisibilityChangeScopeLabel(change)) {
                            <span class="text-muted"> ({{ getVisibilityChangeScopeLabel(change) }})</span>
                          }
                          : {{ getVisibilityValueLabel(change, change.oldValue) }} <i class="ri-arrow-right-line align-bottom"></i> {{ getVisibilityValueLabel(change, change.newValue) }}
                        </div>
                        <div class="fs-11 text-muted">
                          {{ change.changedAtUtc | date:'dd/MM/yyyy HH:mm':'UTC' }} UTC &middot; {{ getVisibilityChangeBy(change) }}
                          @if (change.expiresUtc) {
                            &middot; until {{ change.expiresUtc | date:'dd/MM/yyyy HH:mm':'UTC' }} UTC
                          }
                        </div>
                        @if (change.reason) {
                          <div class="fs-11 text-muted fst-italic">"{{ change.reason }}"</div>
                        }
                      </div>
                    }
                  }
                </div>
              }
            </div>
          }
        </div>
        }
      </div>
    </div>

      <ng-template #worldViewMutlipleCoordinates let-coordinate>
        @if (coordinate.countryId == -1) {
          <div class="d-flex align-items-start justify-content-between">
            <div class="flex-grow-1 overflow-hidden">
              <span class="fs-14 fw-medium text-muted mb-0" style="word-break:break-word;white-space:normal;">  {{coordinate.label}}</span>
            </div>
            @if (companyId != undefined) {
              <span [class]="locationStatusClass(coordinate)">{{ locationStatusLabel(coordinate) }}</span>
            }
          </div>
        } @else {
          <div class="d-flex align-items-start justify-content-between">
            <div class="flex-grow-1 overflow-hidden">
              @if (((coordinate.countryId ?? -1) > -1 || coordinate.countryFlag != undefined) && ((coordinate.countryId ?? -1) != -3)) {
                <img
                    alt=""
                    width="16"
                    [src]="coordinate.countryFlag"
                />
              }
              <span class="fs-14 fw-medium text-muted mb-0" style="word-break:break-word;white-space:normal;">  {{coordinate.label}}</span>
            </div>
            @if (companyId != undefined) {
              <span [class]="locationStatusClass(coordinate)">{{ locationStatusLabel(coordinate) }}</span>
            }
          </div>
        }

        <div class="d-flex col-12 mt-0">
          <p class="fs-12 mb-0 text-align-left text-muted">
            <span>{{ iccid != undefined ? 'Location' : 'SIM' }} count: {{getCountrySimCount(coordinate)}}</span>
          </p>
        </div>

        @if ((coordinate.countryId ?? -1) > -1 || (coordinate.countryId ?? -1) == -3 || (coordinate.countryId ?? -1 < -100000)) {
          <div class="d-flex col-12 mt-0">
            <p class="fs-10 mb-1 text-align-left text-muted">
              <span>{{getCountryDateRange(coordinate)}}</span>
            </p>
          </div>
        }

        <!--RBW_20260713 - Disabled card: enable-location toggle pinned bottom-right (aligned with the last text line) so the status pill owns the top-right-->
        <!--RBW_20260723 - Only in Manage Company (editable), not on the read-only global Location Awareness screen (readOnlySettings) - company location settings are managed from within the company-->
        @if ((coordinate.countryId == -1 || groupHasCountryOnly(coordinate)) && companyId != undefined && !readOnlySettings) {
          <a href="javascript:void(0);" class="text-primary d-inline-block delete-item-btn location-disabled-toggle" id="locationServices-btn" (click)="setCompanyLocationServices($event)">
            <i title="Enable location awareness&#10;for these users"
               class="las la-toggle-off text-danger fs-16"
               style="cursor: pointer;">
            </i>
          </a>
        }
      </ng-template>

      <ng-template #worldViewSingleCoordinate let-coordinate>
        <!--RBW_20260716 - Username + SIM number are only useful on the company/global screen; in Manage SIM the SIM is in the header and the user never changes-->
        @if (iccid == undefined) {
          <div class="d-flex align-items-start justify-content-between">
            <div class="flex-grow-1 overflow-hidden">
              <div class="fs-14 fw-medium text-muted text-truncate mb-0">{{coordinate.username}}
              </div>
            </div>
            @if (companyId != undefined) {
              <div class="d-flex flex-column align-items-end flex-shrink-0 ms-2">
                <span [class]="locationStatusClass(coordinate)">{{ locationStatusLabel(coordinate) }}</span>

                @if (showTravelBriefing && (coordinate.countryId ?? -1) > 0 && (coordinate.country ?? '') !== '') {
                  <button
                    class="btn btn-soft-warning btn-sm mt-1 py-0 px-2 fs-11 text-nowrap"
                    title="Travel Briefing"
                    type="button"
                    (click)="travelBriefingClick($event, coordinate)"
                  >Travel Briefing</button>
                }
              </div>
            }
          </div>
          <div class="d-flex col-12 mt-0">
            <p class="fs-12 mb-0 text-align-left text-muted">
              <span (click)="iccidClick($event, coordinate.iccid ?? '')" [ngClass]="{ 'text-secondary': true }" style="cursor: pointer;">{{coordinate.iccid}}</span>
            </p>
          </div>
        }

        @if ((coordinate.countryId ?? -1) > -1) {
          <div class="d-flex col-12 mt-0">
            <p class="fs-12 mb-0 text-align-left text-muted">
              <span>{{coordinate.placeName}}</span>
            </p>
          </div>
        }
        <div class="d-flex">
          <div class="flex-grow-1 overflow-hidden">
            @if ((coordinate.countryId ?? -1) > -1 || coordinate.countryFlag != undefined) {
              <img
                  alt=""
                  width="12"
                  [src]="coordinate.countryFlag"
              />
            }
            <span class="fs-12 mb-0 text-align-left text-muted">  {{coordinate.country}}</span>
          </div>
        </div>

        @if ((coordinate.countryId ?? -1) > -1 || (coordinate.countryId ?? -1) == -3) {
          <div class="d-flex col-12 mt-0">
            <p class="fs-10 mb-1 text-align-left text-muted">
              <span>Updated: {{coordinate.dateRange}}</span>
            </p>
          </div>

          @if (!showCurrentLocation) {
            <div class="d-flex col-12 mt-0" style="justify-content: space-between;align-items: center;">
              <p class="fs-12 mb-1 text-align-left text-muted" style="font-weight: bold;">
                <span>Network</span>
              </p>
              <p class="fs-12 mb-1 text-muted" style="margin-left:5px;text-align: right;min-width:0;flex:1;word-break:break-word;">
                <span>{{coordinate.network}}</span>
              </p>
            </div>
          }
        } @else if ((coordinate.countryId ?? -1) < -100000) {
          <div class="d-flex col-12 mt-0">
            <p class="fs-10 mb-1 text-align-left text-muted">
              @if (isVisitMode) {
                <span>{{getHomeGuardDateRange(coordinate)}}</span>
              } @else {
                <span>Updated: {{coordinate.dateRange}}</span>
              }
            </p>
          </div>
        }
      </ng-template>

      <ng-template #coordinateView let-coordinate>
        <!--RBW_20260716 - Username + SIM number are only useful on the company/global screen; in Manage SIM the SIM is in the header and the user never changes-->
        @if (iccid == undefined) {
          <div class="d-flex align-items-start justify-content-between">
            <div class="flex-grow-1 overflow-hidden">
              <div class="fs-14 fw-medium text-muted text-truncate mb-0">{{coordinate.username}}
              </div>
            </div>
            @if (companyId != undefined) {
              <div class="d-flex flex-column align-items-end flex-shrink-0 ms-2">
                <span [class]="locationStatusClass(coordinate)">{{ locationStatusLabel(coordinate) }}</span>

                @if (showTravelBriefing && (coordinate.countryId ?? -1) > 0 && (coordinate.country ?? '') !== '') {
                  <button
                    class="btn btn-soft-warning btn-sm mt-1 py-0 px-2 fs-11 text-nowrap"
                    title="Travel Briefing"
                    type="button"
                    (click)="travelBriefingClick($event, coordinate)"
                  >Travel Briefing</button>
                }
              </div>
            }
          </div>
          <div class="d-flex col-12 mt-0">
            <p class="fs-12 mb-0 text-align-left text-muted">
              <span (click)="iccidClick($event, coordinate.iccid ?? '')" [ngClass]="{ 'text-secondary': true }" style="cursor: pointer;">{{coordinate.iccid}}</span>
            </p>
          </div>
        }

        <div class="d-flex">
          <div class="flex-grow-1 overflow-hidden">
            <div class="fs-14 fw-medium text-muted text-truncate mb-0">{{coordinate.placeName}}
            </div>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-grow-1 overflow-hidden">
            @if ((coordinate.countryId ?? -1) > -1 || coordinate.countryFlag != undefined) {
              <img
                  alt=""
                  width="12"
                  [src]="coordinate.countryFlag"
              />
            }
            <span class="fs-12 mb-0 text-align-left text-muted">  {{coordinate.country}}</span>
          </div>
        </div>

        @if ((coordinate.countryId ?? -1) > -1 || (coordinate.countryId ?? -1 < -100000)) {
          <div class="d-flex col-12 mt-0">
            <p class="fs-10 mb-1 text-align-left text-muted">
              <span>{{coordinate.dateRange}}</span>
            </p>
          </div>
        }

        <!--RBW_20260713 - Only show the Network row when a network value is present (it is masked out at Country / Town-City accuracy)-->
        @if (((coordinate.countryId ?? -1) > -1 || (coordinate.countryId ?? -1) == -3) && !showCurrentLocation && coordinate.network) {
          <div class="d-flex col-12 mt-0" style="justify-content: space-between;align-items: center;">
            <p class="fs-12 mb-1 text-align-left text-muted" style="font-weight: bold;">
              <span>Network</span>
            </p>
            <p class="fs-12 mb-1 text-muted" style="margin-left:5px;text-align: right;min-width:0;flex:1;word-break:break-word;">
              <span>{{coordinate.network}}</span>
            </p>
          </div>
        }
      </ng-template>

      <ng-template #simCurrentLocationView let-coordinate>
        @if ((coordinate.countryId ?? -1) > -1) {
          <div class="d-flex col-12 mt-0" style="justify-content: space-between;align-items: center;">
            <p class="fs-12 mb-1 text-align-left text-muted" style="font-weight: bold;">
              <span>Vendor</span>
            </p>
            <p class="fs-12 mb-1 text-align-right text-muted">
              <span>{{sureSimLiveData?.Vendor}}</span>
            </p>
          </div>
          <div class="d-flex col-12 mt-0" style="justify-content: space-between;align-items: center;">
            <p class="fs-12 mb-1 text-align-left text-muted" style="font-weight: bold;">
              <span>Model</span>
            </p>
            <p class="fs-12 mb-1 text-muted" style="margin-left:5px;text-align: right;min-width:0;flex:1;word-break:break-word;">
              <span>{{sureSimLiveData?.Model}}</span>
            </p>
          </div>
          <div class="d-flex col-12 mt-0" style="justify-content: space-between;align-items: center;">
            <p class="fs-12 mb-1 text-align-left text-muted" style="font-weight: bold;">
              <span>Network</span>
            </p>
            <p class="fs-12 mb-1 text-muted" style="margin-left:5px;text-align: right;min-width:0;flex:1;word-break:break-word;">
              <span>{{sureSimLiveData?.VPLMN}}</span>
            </p>
          </div>
          <!-- <div class="d-flex col-12 mt-0" style="justify-content: space-between;align-items: center;">
            <p class="fs-12 mb-1 text-align-left text-muted" style="font-weight: bold;">
              <span>MCCMNC:</span>
            </p>
            <p class="fs-12 mb-1 text-align-right text-muted">
              <span>{{sureSimLiveData?.MCCMNC}}</span>
            </p>
          </div>
          <div class="d-flex col-12 mt-0" style="justify-content: space-between;align-items: center;">
            <p class="fs-12 mb-1 text-align-left text-muted" style="font-weight: bold;">
              <span>APN:</span>
            </p>
            <p class="fs-12 mb-1 text-align-right text-muted">
              <span>{{sureSimLiveData?.APN}}</span>
            </p>
          </div>
          <div class="d-flex col-12 mt-0" style="justify-content: space-between;align-items: center;">
            <p class="fs-12 mb-1 text-align-left text-muted" style="font-weight: bold;">
              <span>IMEI:</span>
            </p>
            <p class="fs-12 mb-1 text-align-right text-muted">
              <span>{{sureSimLiveData?.IMEI}}</span>
            </p>
          </div>
          <div class="d-flex col-12 mt-0" style="justify-content: space-between;align-items: center;">
            <p class="fs-12 mb-1 text-align-left text-muted" style="font-weight: bold;">
              <span>IP:</span>
            </p>
            <p class="fs-12 mb-1 text-align-right text-muted">
              <span>{{sureSimLiveData?.IP}}</span>
            </p>
          </div>
          <div class="d-flex col-12 mt-0" style="justify-content: space-between;align-items: center;">
            <p class="fs-12 mb-1 text-align-left text-muted" style="font-weight: bold;">
              <span>PDP:</span>
            </p>
            <p class="fs-12 mb-1 text-align-right text-muted">
              <span>{{sureSimLiveData?.PDP}}</span>
            </p>
          </div> -->
        }
      </ng-template>

      <ng-template #checkLoadingStatus>
        <div
          *ngIf="loading ; else checkStatus"
          class="loading-note col-12 mt-2"
          [ngStyle]="{
            background: '#fff',
            border: '1px solid #e9ebec'
          }"
        >
          <div class="loading-note-text" style="color: #0d6efd;">Loading...</div>
        </div>
      </ng-template>
      <ng-template #checkStatus>
        <div
          *ngIf="!locationServices ; else noCoordinates"
          class="loading-note col-12 mt-2"
          [ngStyle]="{
            background: '#fff',
            border: '1px solid #e9ebec'
          }"
        >
          <!--RBW_20261021 - A user who has been sent a consent link is not disabled, they are part way through. The
                             wording comes from the status itself so this cannot drift from the pill in Location Settings.-->
          <div class="loading-note-text">{{ locationAwaitingConsent ? locationAwarenessStatusDescription : 'Location Awareness Disabled' }}</div>
        </div>
      </ng-template>
      <ng-template #noCoordinates>
        <div
          class="no-coordinate-note col-12 mt-2"
          [ngStyle]="{
            background: '#fff',
            border: '1px solid #e9ebec'
          }"
        >
          <div class="no-coordinate-note-text">{{companyId == undefined && showCurrentLocation == false ? "No location data found for this range" : "No location data found"}}</div>
        </div>
      </ng-template>
  </div>

  <!--RBW_20260611 - Home guard toast, positioned just to the left of the clicked card (over the map)-->
  @if (localToastVisible) {
    <div class="local-toast bg-info text-white" [style.top.px]="localToastTop" [style.right.px]="localToastRight">{{ localToastMessage }}</div>
  }

<app-completed-modal-nr-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-nr-form>

<app-confirmation-modal-nr-form #toggleConfirmationModal
  (modalYes)="yesToggleLocationServices()"
></app-confirmation-modal-nr-form>

<app-warning-modal-nr-form #warningModalForm
></app-warning-modal-nr-form>